import { useEffect } from 'react'
import { openReplayService } from '../services/openReplayService'
import { userConsentManager } from '../userConsentManager'
import { beforeUnloadSubject } from '../utils/beforeUnloadSubject'
import { flowAnimationService } from '@monthio/react-components'

export const flowFinishedCleanUp = () => {
	userConsentManager.clear()
	openReplayService.stop()
}

export const useFlowCleanupOnLeave = () => {
	useEffect(() => {
		flowAnimationService.showAnimation = false
		const subscription = beforeUnloadSubject.subscribe(flowFinishedCleanUp)
		return () => {
			subscription.unsubscribe()
		}
	}, [])
}
